// extracted by mini-css-extract-plugin
module.exports = {"container":"Divider_container__ym9yC","containerTransperant":"Divider_containerTransperant__DJpud"};